import React, { createContext, useState, useContext } from 'react';
import { userData, modulesData, certsData, caseHistoryData } from '../data/mockData';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(userData);
  const [modules, setModules] = useState(modulesData);
  const [certs, setCerts] = useState(certsData);
  const [cases, setCases] = useState(caseHistoryData);

  const addXp = (amount) => {
    setUser(prev => {
      let newXp = prev.xp + amount;
      let newLevel = prev.level;
      let nextXp = prev.nextLevelXp;
      if (newXp >= nextXp) {
        newLevel += 1;
        nextXp = Math.floor(nextXp * 1.5);
      }
      return { ...prev, xp: newXp, level: newLevel, nextLevelXp: nextXp };
    });
  };

  const completeModule = (moduleId) => {
    const mod = modules.find(m => m.id === moduleId);
    if (mod && !mod.completed) {
      setModules(prev => prev.map(m => m.id === moduleId ? { ...m, completed: true } : m));
      addXp(mod.xp);
    }
  };

  const addCase = (newCase) => {
    setCases(prev => [newCase, ...prev]);
    addXp(50); // XP for solving a case
  };

  return (
    <AppContext.Provider value={{ user, modules, certs, cases, completeModule, addCase }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);